export default "__VITE_ASSET__PpKQlyM6__"